export default __webpack_public_path__ + "static/media/loaderGif.72ce6e72.gif";